module.exports = __webpack_public_path__ + "img/quizz.faf2ff43.png";